export default __webpack_public_path__ + "static/media/gray-glow.bf9cb8ca.png";